import algoliaApi from "@/services/api/algoliaApi";

const algoliaApiService = new algoliaApi();
/**
 * Tracking service.
 * Going forward we should consolidate tracking for datadog, mixpanel, facebook, and google analytics to use this service.
 * For now all it handles is facebook pixel tracking.
 */

/**
 * Top level function to do event tracking.
 *
 * @param {string} name
 * @param {*} params
 */
export default function trackEvent(name, params, events) {
  _fbTrackEvent(name, params, events);
  _algoliaTrackEvent(name, params);
}

/* eslint-disable */

/**
 * Tracking for facebook tracking pixel / fbq
 *
 * @param {string} name
 * @param {*} params
 */
function _fbTrackEvent(name, params, events) {
  const trackParams = params || undefined;
  if (window.fbq === undefined) {
    return;
  }
  switch (name) {
    case "Retailer Button Click":
    case "ViewContent":
    case "PageView":
      window.fbq("track", name);
      break;
    case "Purchase":
      window.fbq("track", name, trackParams, events);
      break;
  }
}

function _algoliaTrackEvent(name, params) {
  switch (name) {
    case "PLP;Product Clicked":
      algoliaApiService.trackClick(name, params);
      break;
    case "PDP;Product Added to Cart after Search":
      algoliaApiService.trackAddToCart(name, params);
      break;
    case "Autocomplete;Product Clicked":
      algoliaApiService.trackClick(name, params);
      break;
    case "AutoComplete;Product Added to Cart after Search":
      algoliaApiService.trackAddToCart(name, params);
      break;
    case "Product Viewed":
      algoliaApiService.trackView(name, params);
      break;
  }
}
